import { BoardParticipant, PartnerRepresentant, Society, User } from 'types';

type GetMemberIdProps = {
  user: User;
  society: Society;
  participants: BoardParticipant[];
  partnerRepresentants: PartnerRepresentant[];
};

const extractIds = (entities: { _id: string }[]) =>
  entities.map((entity) => entity._id);

const getUserMemberIds = (user: User) => [
  ...(user?.partners || []),
  ...(user?.partnerRepresentants || []),
];

const getBoardMembersId = (participants: BoardParticipant[]) =>
  participants.map((participant) => participant.member);

export const getMemberId = ({
  user,
  society,
  participants,
  partnerRepresentants,
}: GetMemberIdProps): string => {
  if (!user || !society) return '';

  const societyPartnersId = extractIds(society?.partners || []);
  const societyRepresentantsId = extractIds(partnerRepresentants);

  const boardMembersId = getBoardMembersId(participants);
  const societyMembersId = [...societyPartnersId, ...societyRepresentantsId];
  const userMembers = getUserMemberIds(user);

  const memberId = societyMembersId.length
    ? userMembers.find(
        (member) =>
          societyMembersId?.includes(member) && boardMembersId?.includes(member)
      )
    : null;

  return memberId || '';
};
